import { FC, useContext, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useMutation } from "react-query";
import {
  getSocialHabitCategory,
  getSocialHabitDescription,
  getSocialLifeCycleStatus,
  getSocialQuantity,
  PostSocialHistoryData,
} from "../../../../services";

import { contextType, SocialHistoryContext } from "../Socialhistory";
import { CustomFormField } from "../../../../../utilis/component/CustomFormElement";
import { socialHistoryform } from "./fieldData";
import { Button, CircularProgress } from "@mui/material";
import { getSocialHistoryType, postSocialHistoryType } from "../type";
import { clinicId } from "../../../../../constants";
import { useParams } from "react-router-dom";
import usePopup from "../../../../../hooks/usePopup";
import { FormOnChangeEventType } from "../../../../types";
import { HL7ContexTriggerContex } from "../../../../../context/HL7MessageTrigger/HL7MessageTriggerProvider";
import useAuthentication from "@hooks/useAuthentication";
import { EmrContext } from "../../../../index";

const SocialHistoryForm: FC<{ close?: () => void }> = ({ close }) => {
  const { encounterId, patientId } = useParams();
  const { handleSubmit, control, reset } = useForm();
  const { showSnackbar } = usePopup();
  const {user} = useAuthentication()
  const { setTrigger } = useContext(HL7ContexTriggerContex);
  const { edit, setsuccess, success, setEdit } = useContext(
    SocialHistoryContext
  ) as contextType;
  const { triggerConsultationStart } = useContext(EmrContext);
  const { mutate: saveData, isLoading: saveLoading } = useMutation(
    PostSocialHistoryData,
    {
      onSuccess: (result) => {
        if (result.responseIndicator == "success") {
          showSnackbar({
            message: result.responseMessage,
            open: true,
            variant: "success",
            duration: 2000,
          });
          setEdit(null);
          setsuccess(!success);
          setTrigger({
            encounterId: encounterId as string,
            tab: "socialhistory",
          });
          triggerConsultationStart();
          reset({
            [socialHistoryform.category.name]: null,
            [socialHistoryform.description.name]: null,
            [socialHistoryform.fromDate.name]: "",
            [socialHistoryform.notes.name]: "",
            [socialHistoryform.quantity.name]: null,
            [socialHistoryform.status.name]: null,
            [socialHistoryform.toDate.name]: "",
          });
        } else {
          showSnackbar({
            message: result.responseMessage,
            open: true,
            variant: "warning",
            duration: 2000,
          });
        }
      },
      onError: () => {
        showSnackbar({
          message: "Something went wrong",
          open: true,
          variant: "success",
          duration: 2000,
        });
      },
    }
  );
  const { mutate: getSocialHabit, data: socialHabitData } = useMutation(
    getSocialHabitCategory
  );
  const { mutate: getSocialDescription, data: socialDescriptionData } =
    useMutation(getSocialHabitDescription);
  const { mutate: getSocialquantity, data: socialQuantityData } =
    useMutation(getSocialQuantity);
  const { mutate: getSocialstatus, data: statusData } = useMutation(
    getSocialLifeCycleStatus
  );

 

  const preprareSocialHistory = (
    data: getSocialHistoryType
  ): postSocialHistoryType => {
    return {
      categoryId: data?.category?.id,
      statusId: data?.status?.id,
      status: 1,
      emrSocialHistoryId: data?.id || 0,
      quantity: data?.quantity?.quantityId,
      fromDate: data?.fromDate == "Invalid date" ? "" : data?.fromDate,
      toDate: data?.toDate == "Invalid date" ? "" : data?.toDate,
      hl7MsgStatus: 0,
      snomedId: data?.description?.snomedId,
      notes: data?.notes,
      createdId: Number(user?.userId),
      clinicId: clinicId,
      createdDate: null,
      patientId: parseInt(patientId as string),
      encounterId: parseInt(encounterId as string),
    };
  };

  const onChange = (event: FormOnChangeEventType) => {
     getSocialDescription(event.target.value.id),
      getSocialquantity(event.target.value.id);

    reset({
      [socialHistoryform.category.name]: event.target.value,
      [socialHistoryform.description.name]: null,
      [socialHistoryform.fromDate.name]: "",
      [socialHistoryform.notes.name]: "",
      [socialHistoryform.quantity.name]: null,
      [socialHistoryform.status.name]: null,
      [socialHistoryform.toDate.name]: "",
    });
  };

  const onsubmit = (data: any) => {
      if(Boolean(edit)){
         console.log(edit);
         const socialHistoryData = preprareSocialHistory({...edit,...data,id:edit.id});
         saveData(socialHistoryData);
      }else{
        const socialHistoryData = preprareSocialHistory({...data,id:null});
        saveData(socialHistoryData);
      }
  };

  useEffect(() => {
    getSocialHabit();
    getSocialstatus();
  }, []);

  useEffect(() => {
    if (Boolean(edit)) {
      console.log(edit);
    if(edit.category.id){ 
      getSocialDescription(edit.category.id) 
      getSocialquantity(edit.category.id);
    }
      reset({
        ...edit,
        [socialHistoryform.quantity.name]: {
          quantityId: edit.quantity.quantityId,
          quantityDesc: edit.quantity.quantityDesc || "",
        },
        [socialHistoryform.status.name]:{
          id:edit.status.id,
          description:edit.status.description || ""
        }
      });
    } else {
      reset({
        category: null,
        description: null,
        quantity: null,
        fromDate: null,
        toDate: null,
        Notes: null,
        Status: null,
      });
    }
  }, [edit]);

  return (
    <div>
      <form onSubmit={handleSubmit(onsubmit)}>
        <div className="grid grid-cols-8 gap-4 m-2">
          <div className="col-span-2">
            <CustomFormField
              control={control}
              options={socialHabitData?.response || []}
              {...socialHistoryform.category}
              rules={{
                ...socialHistoryform.category.rules,
                onChange,
              }}
            />
          </div>
          <div className="col-span-2">
            <CustomFormField
              control={control}
              options={socialDescriptionData?.response || []}
              {...socialHistoryform.description}
            />
          </div>
          <div className="col-span-2">
            <CustomFormField
              control={control}
              options={socialQuantityData?.response || []}
              {...socialHistoryform.quantity}
            />
          </div>

          <div className="col-span-2">
            <CustomFormField control={control} {...socialHistoryform.notes} />
          </div>
          <div className="col-span-2">
            <CustomFormField
              control={control}
              options={statusData?.response || []}
              {...socialHistoryform.status}
            />
          </div>
          <div className="col-span-2">
            <CustomFormField
              control={control}
              {...socialHistoryform.fromDate}
            />
          </div>
          <div className="col-span-2">
            <CustomFormField control={control} {...socialHistoryform.toDate} />
          </div>
          <div className="col-span-2 flex flex-row items-center justify-end gap-2">
            <Button
              type="submit"
              color="success"
              disabled={saveLoading}
              endIcon={saveLoading && <CircularProgress size={18} />}
            >
              Save
            </Button>
            <Button
              color="error"
              onClick={() => {
                close && close();
              }}
            >
              cancel
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default SocialHistoryForm;
